module.exports = __webpack_public_path__ + "static/media/carousel8.42d10933.jpeg";